import { utilsQuery } from "@app/common";

const define = utilsQuery.defineQueryKeyCreator("auth");

export const QueryKeys = {
    Authenticate: define("authenticate"),
    PasswordReset: define("password-reset"),
} as const;
